import api from './api.js'

// Employee Service
export const employeeService = {
  async getAll(params = {}) {
    const response = await api.get('/employees', { params })
    return response.data.success ? response.data.data : []
  },

  async getById(id) {
    const response = await api.get(`/employees/${id}`)
    return response.data.success ? response.data.data : null
  },

  async getStats() {
    const response = await api.get('/employees/stats')
    return response.data.success ? response.data.data : {}
  },

  async sync() {
    const response = await api.post(
      '/employees/sync',
      {},
      {
        timeout: 600000 // 10 minutes for sync operations
      }
    )
    return response.data
  },

  async syncAll() {
    const response = await api.post('/employees/sync-all', {}, { timeout: 600000 })
    return response.data
  },

  async getNotes(employeeId) {
    const response = await api.get(`/employees/${employeeId}/notes`)
    return response.data.success ? response.data.data : ''
  },

  async updateNotes(employeeId, notes) {
    const response = await api.patch(`/employees/${employeeId}/notes`, { notes })
    return response.data
  },

  async deleteAll() {
    const response = await api.delete('/employees/all')
    return response.data
  },

  async getAanspreekpunten() {
    const response = await api.get('/employees/aanspreekpunten')
    return response.data.success ? response.data.data : []
  },

  async getFilterOptions() {
    const response = await api.get('/employees/filter-options')
    return response.data.success ? response.data.data : { functions: [] }
  },

  async getMyTeams(email) {
    const response = await api.get('/employees/my-teams', { params: { email } })
    return response.data.success ? response.data.data : { teams: [] }
  }
}

// Team Service
export const teamService = {
  async getAll() {
    const response = await api.get('/teams')
    return response.data.success ? response.data.data : []
  },

  async getEmployees(teamId) {
    const response = await api.get(`/teams/${teamId}/employees`)
    return response.data.success ? response.data.data : []
  }
}
